class Hand

  @WinTypes = {
    Win: 1
    Blind: 2
  }

  @GetTotal = (hand) ->
    return 0 unless hand?
    
    multipliers = {
      pointsInMelds: 1
      pointsInHand: -1
      mixedCanastas: 300
      naturalCanastas: 500
      redThrees: if hand.pointsInMelds > 0 then 100 else -200
    }
    [
      switch hand.status
        when Hand.WinTypes.Win then 100
        when Hand.WinTypes.Blind then 200
        else 0
      hand.pointsInMelds * multipliers.pointsInMelds
      hand.pointsInHand * multipliers.pointsInHand
      hand.mixedCanastas * multipliers.mixedCanastas
      hand.naturalCanastas * multipliers.naturalCanastas
      hand.redThrees * multipliers.redThrees
    ].reduce (prev, cur) -> prev + cur

  constructor: () ->
    @status = null
    @redThrees = 0
    @mixedCanastas = 0
    @naturalCanastas = 0
    @pointsInHand = 0
    @pointsInMelds = 0

module.exports = Hand